"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCookie = void 0;

getCookie = function getCookie(name) {
  var cookie = void 0;
  var cookieValue = void 0;
  var cookies = void 0;
  var i = void 0;
  cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    cookies = document.cookie.split(";");
    i = 0;
    while (i < cookies.length) {
      cookie = _jquery2.default.trim(cookies[i]);
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
      i++;
    }
  }
  return cookieValue;
};

exports.default = getCookie;